export default __webpack_public_path__ + "static/media/Client Logos – 05 – Vent Over Tea.ab225332.svg";